// BarcodeDetector polyfill（zxing-cpp WebAssembly 版）
// iOS/iPadOS Safari 至今未開放原生 BarcodeDetector（實驗旗標且 17.6 起故障），
// 掛上此 polyfill 後 LinePay 等掃描流程在所有瀏覽器都走同一條 BarcodeDetector 路徑。
import { BarcodeDetector, prepareZXingModule } from "barcode-detector/ponyfill";

// wasm 由 postinstall 複製到 public/wasm/（見 scripts/sync-zxing-wasm.js），
// 從自家網域載入，避免依賴 jsDelivr CDN。
prepareZXingModule({
  overrides: {
    locateFile: (path, prefix) =>
      path.endsWith(".wasm") ? `${process.env.PUBLIC_URL}/wasm/${path}` : prefix + path,
  },
});

// 原生可用時（Android/桌面 Chrome）仍優先使用原生實作
if (!("BarcodeDetector" in window)) {
  window.BarcodeDetector = BarcodeDetector;
}
